import { createCrudActions } from "../utils/crudGenerator";

const formatUploadeddecks = (data) => {
  console.log("🎯 FORMAT DEBUG - Datos recibidos para formatear:", data);
  if (!data) {
    return [];
  }
  const formatItem = (item) => ({
    ...item,
    label: `${item.deckName || item.name || "Sin nombre"}`,
    value: item._id,
  });

  let result;
  if (Array.isArray(data)) {
    result = data.map(formatItem);
  } else {
    result = formatItem(data);
  }

  console.log("🎯 FORMAT DEBUG - Datos formateados:", result);
  return result;
};

export const {
  fetch: fetchUploadeddecks,
  create: createUploadeddeck,
  update: updateUploadeddeck,
  delete: deleteUploadeddecks,
} = createCrudActions("UPLOADEDDECK", "DecksSubido", formatUploadeddecks);
